import api from '@/lib/axios'
import { API_ENDPOINTS } from '@/config/api.constants'
import type { TableViewPayload, TableViewScope, TableViewsListResponse } from '@/types/shared/table-view.types'

function scopeQueryParams(scope: TableViewScope): Record<string, string> {
  const params: Record<string, string> = { scope: scope.scope }
  if (scope.organizationId) params.organizationId = scope.organizationId
  if (scope.branchId) params.branchId = scope.branchId
  return params
}

export async function getTableViews(scope: TableViewScope): Promise<TableViewsListResponse> {
  const response = await api.get<{ success: boolean; data: TableViewsListResponse }>(
    API_ENDPOINTS.USERS.TABLE_VIEWS,
    { params: scopeQueryParams(scope) }
  )
  return response.data?.data ?? { views: {} }
}

export async function upsertTableView(
  scope: TableViewScope,
  viewKey: string,
  payload: TableViewPayload
): Promise<{ viewKey: string; payload: TableViewPayload }> {
  const response = await api.put<{ success: boolean; data: { viewKey: string; payload: TableViewPayload } }>(
    API_ENDPOINTS.USERS.TABLE_VIEW(viewKey),
    { payload },
    { params: scopeQueryParams(scope) }
  )
  return response.data?.data ?? { viewKey, payload }
}

export async function resetTableView(scope: TableViewScope, viewKey: string): Promise<void> {
  await api.delete(API_ENDPOINTS.USERS.TABLE_VIEW(viewKey), { params: scopeQueryParams(scope) })
}
